import { BizSelect } from '../../Mini/BizSelect';
import { getOptionName } from '../formUtils';
import { FormFieldComponentProps } from './fieldProps';

const DropdownField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const noSelectText = (field.settings.noselecttext as string) ?? '';

	const selectOptions = field.options.map((opt) => ({
		Id: String(opt.id),
		Name: getOptionName(opt.translations),
	}));

	const handleChange = (option: { Id: string; Name: string } | null) => {
		onChange(option?.Id ?? '');
	};

	return (
		<div onBlur={onBlur}>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<BizSelect
				options={selectOptions}
				selectedId={value || null}
				onChange={handleChange}
				disabled={disabled}
				noSelectText={noSelectText}
			/>
		</div>
	);
};

export default DropdownField;
